// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"34d97eb5","396":"2eb7202f","455":"a3aac68b","804":"d1b8d2ab","977":"0eadd01f"}[chunkId] + ".chunk.js";
};